<template>
  <div dir="rtl">
    <b-container>
      <b-row class="mt-5">

        <b-col md="4" class="mb-4">
          <b-form-input
              id="input"
              placeholder=" جستجو"
              debounce="500"
              v-model="searchWords"
              class="mb-1"
          ></b-form-input>

          <div class="feature_box_selector text-right shadow p-2 rounded">
            <p @click="addToFeatureTable(feature.name)" class="w-100 feature_box_selector_item"
               v-for="feature in Features" v-if="feature.type==='list'">{{ feature.name }}</p>
          </div>


        </b-col>

        <b-col md="8">

          <b-form-group class="w-100 text-center" label-for="table">
            <b-table id="table" striped hover :fields="fields" :items="items">
              <template #cell(value)="data">

                <b-form-select
                    :options="data.item.feature_attributes"
                    v-model="data.item.value"
                    v-if="data.item.type == 'list'"
                ></b-form-select>
                <b-form-textarea v-model="data.item.value" v-else/>
              </template>
              <template #cell(action)="data">
              <span
                  class="h5"
                  @click="deleteFeature(data.item)"
                  v-b-tooltip.hover
                  title="حذف"
              >
                <b-icon icon="trash"></b-icon>
              </span>
              </template>
            </b-table>
          </b-form-group>
        </b-col>

        <b-col lg="12" class="text-left">
          <b-button @click="generateFeatureAttributesCombination()" pill variant="success">ساخت حالات</b-button>
        </b-col>

        <b-container class="text-center mt-5">
          <div class="row">
            <b-col lg="12">
              <div v-for="feature in featureAttributesCombination" v-show="feature.show" class="input-group mt-3"
                   dir="ltr">
                <div class="input-group-prepend">
                  <button @click="addToFeatureMainTable(feature)" class="btn btn-secondary" type="button">
                    <b-icon icon="check-circle"></b-icon>
                  </button>
                </div>

                <input readonly dir="rtl" type="text" v-model="feature.text"
                       class="form-control text-right">

              </div>
            </b-col>
          </div>
        </b-container>


      </b-row>
    </b-container>
  </div>
</template>
<script>
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "FeaturesManager",
  props: ["selectFeature", "itemsTable", "Features", 'featureItemTable'],
  data() {
    return {
      fields: [
        {key: "name", label: "نام ویژگی"},
        {key: "action", label: ""},
      ],
      selectedFeature: this.selectFeature,
      items: this.itemsTable,
      features: this.Features,
      searchedWord: '',
      featureAttributesCombination: [],
    };
  },
  computed: {
    searchWords: {
      get() {
        return this.searchedWord;
      },
      set(searchedWord) {
        if (searchedWord != "") {
          const searchWord = {words: searchedWord};
          this.$store.dispatch("Feature/filteredFeatures", searchWord);
        }
      },
    },
  },
  methods: {
    deleteFeature(feature) {
      this.items.splice(this.items.indexOf(feature), 1);
    },
    addToFeatureTable(selectedFeature) {
      if (this.items.length == 2) {
        toast('خطا', 'بیشتر از دو ویژگی پشتیبانی نمیشود.', 'danger')
        return false;
      }
      for (let i in this.Features) {
        if (selectedFeature == this.Features[i].name) {

          let value = "";
          let feature_attributes = [];
          if (this.Features[i].feature_attributes.length > 0) {
            let temp_value = this.Features[i];
            value = temp_value.type == 'list' ? temp_value.feature_attributes[0].id : temp_value.feature_attributes[0].value;
            this.Features[i].feature_attributes.forEach(item => {
              feature_attributes.push({value: item.id, text: item.value});
            })
          }

          let f = {
            id: this.Features[i].id,
            name: this.Features[i].name,
            feature_attributes: feature_attributes,
            type: this.Features[i].type,
            value: value,
          };
          this.selectedFeature.push(f);
          this.items.push(f);
        }
      }
    },
    cartesian(...args) {
      var r = [], max = args.length - 1;

      function helper(arr, i) {
        for (var j = 0, l = args[i].length; j < l; j++) {
          var a = arr.slice(0); // clone arr
          a.push(args[i][j]);
          if (i == max)
            r.push(a);
          else
            helper(a, i + 1);
        }
      }

      helper([], 0);
      return r;
    },
    generateFeatureAttributesCombination() {


      /*
       ویژگی های داینامیک محصولات باید ظاهر یکسانی داشته باشند،
       مثلا یک ویژگی نمیتواند هم به صورت تکی هم به صورتی چند تایی برای یک محصول در دسترس قرار گیرد.
       */
      this.featureAttributesCombination = []
      let checker = true
      let itemsInMainTable = []

      this.featureItemTable.forEach(item => {

        if (item.text != undefined && item.variation == 1) {
          itemsInMainTable.push(item.name)
        }

      });


      let selectedCombinationName = []

      this.items.forEach(item => {
        selectedCombinationName.push(item.name)
      })

      selectedCombinationName = selectedCombinationName.join(' - ')


      if (itemsInMainTable.length === 0) {
        checker = false
      } else {
        checker =  itemsInMainTable.indexOf(selectedCombinationName) === -1
      }

      if (checker) {
        toast('خطا', 'ویژگی ساخته شده باید با ویژگی های قبلی شکل یکسانی داشته باشد.');
        return false
      }

      // set itemsInMainTable to normal value to filter generated item
      itemsInMainTable = this.featureItemTable.map(item => {
        if (item.text != undefined) return item.text
      });


      this.featureAttributesCombination = this.cartesian(...this.items.map(item => item.feature_attributes)).map(attribute => {
        let attributeName = attribute.map(attribute => attribute.text).join(' - ');

        return {
          name: this.items.map(item => item.name).join(' - '),
          text: attribute.map(attribute => attribute.text).join(' - '),
          value: attribute.map(attribute => attribute.text).join(' - '),
          feature_id: this.items.map(item => item.id),
          feature_attributes: attribute.map((attribute) => attribute.value),
          link_feature_id: this.items.map(item => item.id).slice(0, -1),
          variation: 1,
          quantity: null,
          offer: null,
          price: null,
          show: itemsInMainTable.indexOf(attributeName) == -1,
        }


      });
    },
    addToFeatureMainTable(feature) {
      // remove feature from featureAttributesCombination
      this.featureAttributesCombination.splice(this.featureAttributesCombination.indexOf(feature), 1);

      this.featureItemTable.push(feature);
    }
  },
  mounted() {
  }
};
</script>
<style scoped>
.feature_box_selector {
  height: 150px;
  width: 100%;
  overflow-x: auto;
}

.feature_box_selector_item {
  cursor: pointer;
}

</style>